module.exports = __webpack_public_path__ + "img/p-sec01-img15.8f45207d.png";